import { DateTime } from 'luxon'
// import { createFormatter } from 'next-intl'
// import { validLocales } from '@/modules/langService/validLocales'

function formatRelativeOrFullDate (timestamp: string, locale: string = 'en') {
  // const supportedLocales = Intl.DateTimeFormat.supportedLocalesOf(validLocales)
  const date = DateTime.fromISO(timestamp) // Parse the ISO date

  if (date.diffNow().as('days') > -14) { // less than 14 days old
    return date.toRelative({ locale })
  }

  // otherwise return full date
  return date.toLocaleString(DateTime.DATE_MED, { locale })
}

export default formatRelativeOrFullDate
